<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdjust_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.333 2.667a.667.667 0 0 0-.666.666v3.334H2A.667.667 0 0 0 2 8h.667v4.667a.667.667 0 1 0 1.333 0V8h.667a.667.667 0 0 0 0-1.333H4V3.333a.667.667 0 0 0-.667-.666m4.667 0a.667.667 0 0 0-.667.666V10h-.666a.667.667 0 0 0 0 1.333h.666v1.334a.667.667 0 1 0 1.334 0v-1.334h.666a.667.667 0 1 0 0-1.333h-.666V3.333A.667.667 0 0 0 8 2.667m4 .666a.667.667 0 0 1 1.333 0v1.334H14A.667.667 0 1 1 14 6h-.667v6.667a.667.667 0 1 1-1.333 0V6h-.667a.667.667 0 1 1 0-1.333H12z"
        clip-rule="evenodd"
    />
</svg>
